<!-- src/components/LoadingIndicator.vue -->
<template>
  <div v-if="isLoading" class="loading-overlay">
    <img src="@/assets/loading.gif" alt="Loading..." class="loading-gif" />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { loadingService } from '../services/loading-service';

export default defineComponent({
  name: 'LoadingIndicator',
  setup() {
    const isLoading = computed(() => loadingService.isLoading.value);
    return {
      isLoading,
    };
  },
});
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure it's on top of all other elements */
}

.loading-gif {
  width: 100px; /* Adjust size as needed */
  height: 100px;
}
</style>
